import * as React from "react";
import { connect } from "react-redux";
import { Dispatch, bindActionCreators } from "redux";
import { hot } from "react-hot-loader";

import { feedAvailable } from "../../lib/i18n";
import { RootState } from "../../state";
import { Company } from "../entities";
import { loadCompanyShowWorker, draftCompanyUpdated } from "../actions";
import { Country } from "../../common/actions/Auth";
import { modalOpened } from "../../common/actions/Modal";
import Translate from "../../common/components/Translate";
import SectionNavigator from "../../common/components/SectionNavigator";
import SectionNav from "./SectionNav";
import MissionSection from "./MissionSection";
import ProjectsSectionContainer from "./ProjectsSectionContainer";
import MembersSectionContainer from "./MembersSectionContainer";
import ValuesSectionContainer from "./ValuesSectionContainer";
import PortfolioSectionContainer from "./PortfolioSectionContainer";
import FeaturedPostsSectionContainer from "./FeaturedPostsSectionContainer";
import BasicInfoSection from "./BasicInfoSection";
import CompanyValuesShareMegaphoneContainer from "./CompanyValuesShareMegaphoneContainer";

interface MappedProps {
  company: Company;
  editMode: boolean;
  country: Country;
  locale: string;
  isLoaded: boolean;
}
interface MappedActions {
  draftCompanyUpdated: typeof draftCompanyUpdated;
  loadCompanyShowWorker: (company: Company) => void;
  modalOpened: typeof modalOpened;
}
type Props = MappedProps & MappedActions;

class ShowContainer extends React.Component<Props> {
  public static async fetchInitialData(getState: () => RootState, dispatch: Dispatch<RootState>) {
    const state = getState();
    const company = state.companies.common.draftCompany;
    await dispatch(loadCompanyShowWorker(company));
  }

  public onOpenEditBasicInfoModal = () => {
    this.props.modalOpened({
      name: "companies/edit-basic-info",
    });
  };

  public onChangeCompany = (company: Company) => {
    this.props.draftCompanyUpdated(company);
  };

  public render() {
    const { company, isLoaded, locale, country, editMode } = this.props;

    return (
      <div>
        {isLoaded ? (
          <>
            <SectionNavigator
              renderNav={props => (
                <SectionNav
                  {...props}
                  navTitle={<Translate id="company.nav.home" />}
                  activeColor={company.font_color_code}
                />
              )}
            >
              <MissionSection locale={locale} company={company} editable={editMode} onChange={this.onChangeCompany} />
              {feedAvailable(country) && <FeaturedPostsSectionContainer showAllPostsLink />}
              <ValuesSectionContainer />
              {editMode && <CompanyValuesShareMegaphoneContainer company={company} />}
              <PortfolioSectionContainer locale={locale} editable={editMode} />
              <MembersSectionContainer locale={locale} editable={editMode} />
              <ProjectsSectionContainer locale={locale} editable={editMode} />
              <BasicInfoSection
                locale={locale}
                company={company}
                editable={editMode}
                onEdit={this.onOpenEditBasicInfoModal}
              />
            </SectionNavigator>
          </>
        ) : (
          <span>Loading...</span>
        )}
      </div>
    );
  }
}

function mapStateToProps(state: RootState): MappedProps {
  return {
    company: state.companies.common.draftCompany!,
    editMode: state.companies.common.editMode,
    isLoaded: state.companies.show.isLoaded,
    country: state.auth.country,
    locale: state.auth.locale,
  };
}

function mapDispatchToProps(dispatch: Dispatch<RootState>): MappedActions {
  return bindActionCreators(
    {
      loadCompanyShowWorker,
      draftCompanyUpdated,
      modalOpened,
    },
    dispatch
  );
}

const connected = connect(mapStateToProps, mapDispatchToProps)(ShowContainer);
export default hot(module)(connected);



// WEBPACK FOOTER //
// ./frontend/src/companies/components/ShowContainer.tsx